import useHttpProvider from "@/common/hooks/use-http";
import { AccumulatedEntries, getUserAccumulatedEntries } from "@/features/payments/services/entries";
import { useEffect, useState } from "react";

function AccumulatedEntriesComponent() {
	const { http } = useHttpProvider();
	const [accumulatedEntries, setAccumulatedEntries] = useState<AccumulatedEntries | null>(null);

	const getAccumulatedEntries = async () => {
		const entries = await getUserAccumulatedEntries(http);
		setAccumulatedEntries(entries);
	};

	useEffect(() => {
		getAccumulatedEntries();
	}, []);

	if (!accumulatedEntries || (accumulatedEntries.monthlyPoints === 0 && accumulatedEntries.weeklyPoints === 0)) {
		return null;
	}

	return (
		<div className="flex flex-col gap-8">
			<p className="web-heading-h4">Your Accumulated Entries</p>
			
			<div
				className="relative flex flex-col gap-6 rounded-[24px] py-8 px-6 text-center"
				style={{
					background:
						"radial-gradient(171.4% 138.54% at 80.57% 8.23%, rgba(46, 219, 202, 0.30) 18.51%, rgba(8, 50, 46, 0.00) 100%), linear-gradient(180deg, #004096 -29.98%, #470096 122.31%)",
					backgroundBlendMode: "plus-lighter, normal",
				}}
			>
				<img
					src="/images/entries.png"
					className="absolute right-5 -bottom-6 h-18 w-20 md:-top-6 md:right-20"
				/>
				
				{accumulatedEntries.monthlyPoints > 0 && (
					<span className="web-body-b2-medium text-white">
						You have accumulated{" "}
						<span className="text-green-300">
							{accumulatedEntries.monthlyPoints} entries
						</span>{" "}
						for monthly draws
					</span>
				)}
				
				{accumulatedEntries.weeklyPoints > 0 && (
					<span className="web-body-b2-medium text-white">
						You have accumulated{" "}
						<span className="text-green-300">
							{accumulatedEntries.weeklyPoints} entries
						</span>{" "}
						for weekly draws
					</span>
				)}
			</div>
		</div>
	);
}

export default AccumulatedEntriesComponent;
